import { CheckCircleOutlined, SyncOutlined } from '@ant-design/icons'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useQuery } from '@tanstack/react-query'
import { Button, Modal, ModalProps } from 'antd'
import { useTranslation } from 'contexts/Localization'
import { getBuyMBCStatus } from 'state/nfts/api'

interface ModalWaitingBuyMBCProps extends ModalProps {}

const ModalWaitingBuyMBC: React.FC<ModalWaitingBuyMBCProps> = ({ ...props }) => {
  const { visible, remove, hide } = useModal()
  const { t } = useTranslation()

  /**
   * api
   * ====================================================================
   */

  const { data, isLoading } = useQuery(['buy-mbc-status'], getBuyMBCStatus, {
    enabled: visible,
    refetchInterval: 1000,
    refetchOnMount: true,
  })

  const isSuccess = !['PROCESSING', 'SWAPPING']?.includes(data?.status)

  /**
   * useEffect
   * ====================================================================
   */

  /**
   * render view
   * ====================================================================
   */

  return (
    <Modal
      open={visible}
      onCancel={hide}
      afterClose={remove}
      {...props}
      width={400}
      title={t('Buy MBC')}
      footer={false}
      classNames={{ footer: '!mt-0' }}
      closable={isSuccess}
      maskClosable={false}
    >
      <div className="flex flex-col gap-4">
        {isLoading || !isSuccess ? (
          <SyncOutlined spin rev={undefined} className="self-center text-6xl" />
        ) : (
          <CheckCircleOutlined rev={undefined} className="self-center text-6xl text-system-safe" />
        )}

        <p className="text-center">
          {isSuccess ? t('Successfully buy MBC.') : t('The transaction is in progress, please wait a moment.')}
        </p>
        <Button disabled={!isSuccess} onClick={hide}>
          {t('Close')}
        </Button>
      </div>
    </Modal>
  )
}

export default NiceModal.create(ModalWaitingBuyMBC)
